<div class="o-grid">
  <div class="o-grid__cell">
    <div class="u-wrapper" [ngStyle]="!vm.isInitialized && {'min-height': '200px'}" >
      <div class="c-card u-osb-md">
        <div class="c-content c-content--lg">
          <div class="o-grid o-grid--center-v">
            <div class="o-grid__cell">
              <section>
                <div class="o-grid">
                  <div class="o-grid__cell c-cell">
                    <p class="c-text c-text--lg c-text--bold u-ost-md u-osb-md">{{ 'XRoadConsentService.Header' | translate }}</p>
                    <p class="c-text u-ost-md u-osb-md">{{ 'XRoadConsentService.Description_1' | translate }}</p>
                    <p class="c-text u-ost-md u-osb-md">{{ 'XRoadConsentService.Description_2' | translate }}</p>
                    <p class="c-text u-ost-md u-osb-md">{{ 'XRoadConsentService.Description_3' | translate }}</p>
                    <p class="c-text u-ost-md u-osb-md">{{ 'XRoadConsentService.Description_4' | translate }}</p>
                    <p class="c-text c-text--bold u-ost-md u-osb-md" *ngIf="!vm.userConsentsDto?.xRoadConsentKirstInsured && vm.userConsentsDto?.xRoadConsentRetsPrescriptionDetailed">
                      {{ 'XRoadConsentService.Error_1' | translate }}
                    </p>
                    <p class="c-text c-text--bold u-ost-md u-osb-md" *ngIf="vm.userConsentsDto?.xRoadConsentKirstInsured && !vm.userConsentsDto?.xRoadConsentRetsPrescriptionDetailed">
                      {{ 'XRoadConsentService.Error_2' | translate }}
                    </p>
                    <p class="c-text c-text--bold u-ost-md u-osb-md" *ngIf="!vm.userConsentsDto?.xRoadConsentKirstInsured && !vm.userConsentsDto?.xRoadConsentRetsPrescriptionDetailed">
                      {{ 'XRoadConsentService.Error_3' | translate }}
                    </p>
                    
                    <loader-overlay *ngIf="vm.loading" [theme]="3"></loader-overlay>
           
                    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed u-no-p u-ost-lg c-text--center u-hidden@sm-and-up"
                         style="position: fixed; bottom: 49px; left: 15px; right: 15px; height: 50px">
                      <button type="button" (click)="vm.goToRedirectUrl()" class="c-button c-button--s1 c-button--lg c-button--fit@up-to-sm u-osb-md u-osr-md">
                        <span>{{ 'XRoadConsentService.Redirect_Button' | translate }}</span>
                      </button>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed  u-no-p u-ost-lg c-text--center u-hidden@up-to-sm">
                      <button type="button" (click)="vm.goToRedirectUrl()" class="c-button c-button--s1 c-button--lg c-button--fit@up-to-sm u-osb-md u-osr-md">
                        <span>{{ 'XRoadConsentService.Redirect_Button' | translate }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
